import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import MainLayout from '@/layouts/MainLayout';
import { LoginForm } from '@/components/LoginForm/LoginForm';
import LanguageSelector from '@/components/LanguageSelector/LanguageSelector';
import styles from './LoginPage.module.css';
import { getReturnUrlFromQuery } from '@/lib/urls';
import { getLoginStatus } from '@/services/api';
import { SPA_ROUTES } from '@/lib/paths';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const returnUrl = getReturnUrlFromQuery();
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    const ac = new AbortController();

    getLoginStatus({ returnUrl, signal: ac.signal })
      .then((data) => {
        if (!data || data.showLogin) {
          setCheckedAuth(true);
          return;
        }

        if (data.redirectUrl) {
          window.location.assign(data.redirectUrl);
          return;
        }

        navigate(SPA_ROUTES.MANAGE, { replace: true });
      })
      .catch(() => setCheckedAuth(true));

    return () => ac.abort();
  }, [navigate, returnUrl]);

  if (!checkedAuth) return null;

  return (
    <MainLayout returnUrl={returnUrl}>
      <div className={styles.header}>
        <div className={styles.brand}>
          <Trans i18nKey="tobii_dynavox_single_sign_on_naming" />
        </div>
        <h1 className="pageTitle">{t('Log_in_to_your_account')}</h1>
      </div>
      <LoginForm returnUrl={returnUrl} />
      <LanguageSelector />
    </MainLayout>
  );
}
